export const indVsSlTestMatch = {
  _id: '6225783d17d940379f6d67d1',
  apiMatchId: '51547',
  competition: {
    cid: 122169,
    title: 'Sri Lanka tour of India',
    abbr: 'SLTOI',
    type: 'tour',
    category: 'international',
    match_format: 'mixed',
    status: 'live',
    season: '2022',
    datestart: '2022-02-25',
    dateend: '2022-03-18',
    country: 'int',
    total_matches: '5',
    total_rounds: '2',
    total_teams: '2'
  },
  competitionTypeId: '6094d1232484deb6cdcce481',
  createdOn: '2022-03-07T03:13:01.061Z',
  endDate: '2022-03-17T08:30:00.000Z',
  formatString: 'Test',
  gameState: 0,
  gameStateText: 'Default',
  lineupsOut: true,
  preSquad: true,
  result: {},
  startDate: '2022-03-12T08:30:00.000Z',
  status: 2,
  statusText: 'Completed',
  subtitle: '2nd Test (D/N)',
  teamA: {
    team_id: 25,
    name: 'India',
    short_name: 'IND',
    logo_url: 'https://images.entitysport.com/assets/uploads//2023/01/india-4.png'
  },
  teamB: {
    team_id: 21,
    name: 'Sri Lanka',
    short_name: 'SL',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/Sri_Lanka.png'
  },
  timestampEnd: 1647505800,
  timestampStart: 1647073800,
  title: 'India vs Sri Lanka',
  venue: {
    venue_id: '20',
    name: 'M.Chinnaswamy Stadium, Bengaluru',
    location: 'Bengaluru',
    timezone: '-12'
  },
  verified: true,
  isContestListed: true,
  modifiedOn: '2022-03-14T12:32:00.022Z'
};
export const indVsSaT20Match = {
  _id: '63344fdc258445b807480bf7',
  apiMatchId: '56582',
  competition: {
    cid: 125630,
    title: 'South Africa tour of India',
    abbr: 'SATOI',
    type: 'series',
    category: 'international',
    match_format: 'mixed',
    status: 'live',
    season: '2022',
    datestart: '2022-09-28',
    dateend: '2022-10-11',
    country: 'int',
    total_matches: '6',
    total_rounds: '2',
    total_teams: '2'
  },
  competitionTypeId: '604e03b191d702d01cd0a41e',
  createdOn: '2022-09-28T13:45:00.034Z',
  endDate: '2022-10-02T23:30:00.000Z',
  formatString: 'T20I',
  gameState: 0,
  gameStateText: 'Default',
  lineupsOut: true,
  preSquad: true,
  result: {},
  startDate: '2022-10-02T13:30:00.000Z',
  status: 2,
  statusText: 'Completed',
  subtitle: '2nd T20I',
  teamA: {
    team_id: 25,
    name: 'India',
    short_name: 'IND',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/India.png'
  },
  teamB: {
    team_id: 19,
    name: 'South Africa',
    short_name: 'SA',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/South_Africa.png'
  },
  timestampEnd: 1664753400,
  timestampStart: 1664717400,
  title: 'India vs South Africa',
  venue: {
    venue_id: '142',
    name: 'Barsapara Cricket Stadium, Guwahati',
    location: 'Guwahati',
    timezone: '-12'
  },
  verified: true,
  isContestListed: true,
  description: {
    short: '₹2 Lakh + ₹3000 In ₹3!',
    long: 'Contests For Masters!'
  },
  priority: 1,
  modifiedOn: '2022-10-02T17:52:00.013Z',
  adminVerified: true
};
export const slVsAfgT20Match = {
  _id: '630727157e2d41535f39f628',
  apiMatchId: '56612',
  adminVerified: true,
  competition: {
    cid: 125645,
    title: 'Asia Cup',
    abbr: 'AC',
    type: 'tournament',
    category: 'international',
    match_format: 't20i',
    status: 'live',
    season: '2022',
    datestart: '2022-08-27',
    dateend: '2022-09-11',
    country: 'int',
    total_matches: '13',
    total_rounds: '2',
    total_teams: '6'
  },
  competitionTypeId: '604e03b191d702d01cd0a41e',
  createdOn: '2022-08-25T07:39:01.035Z',
  endDate: '2022-08-28T00:00:00.000Z',
  formatString: 'T20I',
  gameState: 0,
  gameStateText: 'Default',
  lineupsOut: true,
  preSquad: true,
  result: {},
  startDate: '2022-08-27T14:00:00.000Z',
  status: 2,
  statusText: 'Completed',
  subtitle: '1st Match, Group B',
  teamA: {
    team_id: 21,
    name: 'Sri Lanka',
    short_name: 'SL',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/Sri_Lanka.png'
  },
  teamB: {
    team_id: 498,
    name: 'Afghanistan',
    short_name: 'AFG',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/Afghanistan.png'
  },
  timestampEnd: 1661644800,
  timestampStart: 1661608800,
  title: 'Sri Lanka vs Afghanistan',
  venue: {
    venue_id: '100',
    name: 'Dubai International Cricket Stadium',
    location: 'Dubai',
    timezone: '-12'
  },
  verified: true,
  isContestListed: true,
  description: {
    short: '₹60K + ₹3000 In ₹3!',
    long: 'contests for winners!'
  },
  priority: 2,
  modifiedOn: '2022-08-27T17:10:00.014Z',
  entryFeeContestLeaderBoardStatus: 'COMPLETED',
  entryFeeContestLeaderboardComment: null
};

export const wiWVsIndWT20Match = {
  _id: '63cc017596851a4d7f92dbc2',
  apiMatchId: '60160',
  competition: {
    cid: 127321,
    title: 'T20 international',
    abbr: 'WT20IT-SISA',
    type: 'series',
    category: 'women',
    match_format: 'woment20',
    season: '2023',
    status: 'live',
    datestart: '2023-01-19',
    dateend: '2023-02-02',
    country: 'int',
    total_matches: '7',
    total_rounds: '1',
    total_teams: '3'
  },
  competitionTypeId: '6094d1232484deb6cdcce47f',
  createdOn: '2023-01-21T15:15:00.637Z',
  endDate: '2023-01-30T23:00:00.000Z',
  formatString: 'Women T20',
  gameState: 0,
  gameStateText: 'Default',
  isBallThrown: false,
  lineupsOut: false,
  preSquad: true,
  result: {},
  startDate: '2023-01-30T13:00:00.000Z',
  status: 1,
  statusText: 'Scheduled',
  subtitle: '6th Match',
  teamA: {
    team_id: 10272,
    name: 'West Indies Women',
    short_name: 'WI-W',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/03/west-indies-over-50s-32x32.png'
  },
  teamB: {
    team_id: 9536,
    name: 'India Women',
    short_name: 'IND-W',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/India.png'
  },
  timestampEnd: 1675119600,
  timestampStart: 1675083600,
  title: 'West Indies Women vs India Women',
  venue: {
    venue_id: '79',
    name: 'Buffalo Park, East London',
    location: 'East London',
    country: 'South Africa',
    timezone: ''
  },
  verified: false,
  isContestListed: true,
  PreviousMatchesPointsComment: null,
  PreviousMatchesPointsStatus: 'COMPLETED'
};
export const engWVsAusWU19Match = {
  _id: '63d166dc96851a4d7f804920',
  apiMatchId: '59505',
  competition: {
    cid: 127108,
    title: 'T20 World Cup',
    abbr: 'ICCWUTWC',
    type: 'tournament',
    category: 'women',
    match_format: 'woment20',
    season: '2023',
    status: 'live',
    datestart: '2023-01-14',
    dateend: '2023-01-29',
    country: 'int',
    total_matches: '41',
    total_rounds: '1',
    total_teams: '16'
  },
  competitionTypeId: '604e03b191d702d01cd0a41e',
  createdOn: '2023-01-25T17:29:00.034Z',
  endDate: '2023-01-27T21:45:00.000Z',
  formatString: 'Women T20',
  gameState: 0,
  gameStateText: 'Default',
  lineupsOut: false,
  preSquad: true,
  result: {},
  startDate: '2023-01-27T11:45:00.000Z',
  status: 1,
  statusText: 'Scheduled',
  subtitle: '2nd Semi-Final',
  teamA: {
    team_id: 127123,
    name: 'England Women Under-19s',
    short_name: 'ENG-W',
    logo_url: 'https://images.entitysport.com/assets/uploads//2023/01/England-6.png'
  },
  teamB: {
    team_id: 127109,
    name: 'Australia Women Under-19s',
    short_name: 'AUS-W',
    logo_url: 'https://images.entitysport.com/assets/uploads//2023/01/Australia-1.png'
  },
  timestampEnd: 1674855900,
  timestampStart: 1674819900,
  title: 'England Women Under-19s vs Australia Women Under-19s',
  venue: {
    venue_id: '66',
    name: 'Senwes Park, Potchefstroom',
    location: 'Potchefstroom',
    country: 'South Africa',
    timezone: '-12'
  },
  verified: false,
  isContestListed: true,
  description: {
    short: '2X Winnings!',
    long: '2X Winnings!'
  }
};
export const indVsZimMatch = {
  _id: '62fdf2711f7aacc4e352a767',
  apiMatchId: '56250',
  competition: {
    cid: 125495,
    title: 'India tour of Zimbabwe',
    abbr: 'ITOZ',
    type: 'tour',
    category: 'international',
    match_format: 'odi',
    status: 'live',
    season: '2022',
    datestart: '2022-08-18',
    dateend: '2022-08-22',
    country: 'int',
    total_matches: '3',
    total_rounds: '1',
    total_teams: '2'
  },
  competitionTypeId: '604e03b191d702d01cd0a41f',
  createdOn: '2022-08-18T08:04:01.161Z',
  endDate: '2022-08-21T01:15:00.000Z',
  formatString: 'ODI',
  gameState: 3,
  gameStateText: 'Play Ongoing',
  lineupsOut: true,
  preSquad: true,
  result: {},
  startDate: '2022-08-20T07:15:00.000Z',
  status: 3,
  statusText: 'Live',
  subtitle: '2nd ODI',
  teamA: {
    team_id: 493,
    name: 'Zimbabwe',
    short_name: 'ZIM',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/Zimbabwe.png'
  },
  teamB: {
    team_id: 25,
    name: 'India',
    short_name: 'IND',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/India.png'
  },
  timestampEnd: 1661044500,
  timestampStart: 1660979700,
  title: 'Zimbabwe vs India',
  venue: {
    venue_id: '13',
    name: 'Harare Sports Club',
    location: 'Harare',
    timezone: '-12'
  },
  verified: false,
  isContestListed: true,
  description: {
    short: '₹1 Lakh + ₹3000 In ₹3!',
    long: 'Contests For Masters!'
  },
  priority: 1,
  modifiedOn: '2022-08-20T13:02:00.069Z'
};
export const saWVsIndWMatch = {
  _id: '63cbff1d96851a4d7f92725d',
  apiMatchId: '60159',
  competition: {
    cid: 127321,
    title: 'T20 international',
    abbr: 'WT20IT-SISA',
    type: 'series',
    category: 'women',
    match_format: 'woment20',
    season: '2023',
    status: 'live',
    datestart: '2023-01-19',
    dateend: '2023-02-02',
    country: 'int',
    total_matches: '7',
    total_rounds: '1',
    total_teams: '3'
  },
  competitionTypeId: '6094d1232484deb6cdcce47f',
  createdOn: '2023-01-21T15:05:00.604Z',
  endDate: '2023-01-29T03:00:00.000Z',
  formatString: 'Women T20',
  gameState: 0,
  gameStateText: 'Default',
  isBallThrown: false,
  lineupsOut: false,
  preSquad: true,
  result: {},
  startDate: '2023-01-28T17:00:00.000Z',
  status: 1,
  statusText: 'Scheduled',
  subtitle: '5th Match',
  teamA: {
    team_id: 10279,
    name: 'South Africa Women',
    short_name: 'SA-W',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/South_Africa.png'
  },
  teamB: {
    team_id: 9536,
    name: 'India Women',
    short_name: 'IND-W',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/India.png'
  },
  timestampEnd: 1674961200,
  timestampStart: 1674925200,
  title: 'South Africa Women vs India Women',
  venue: {
    venue_id: '79',
    name: 'Buffalo Park, East London',
    location: 'East London',
    country: 'South Africa',
    timezone: ''
  },
  verified: false,
  isContestListed: true,
  PreviousMatchesPointsComment: null,
  PreviousMatchesPointsStatus: 'COMPLETED'
};
export const indWVsNzWU19Match = {
  _id: '63d1792496851a4d7f831eb1',
  apiMatchId: '59504',
  competition: {
    cid: 127108,
    title: 'T20 World Cup',
    abbr: 'ICCWUTWC',
    type: 'tournament',
    category: 'women',
    match_format: 'woment20',
    season: '2023',
    status: 'live',
    datestart: '2023-01-14',
    dateend: '2023-01-29',
    country: 'int',
    total_matches: '41',
    total_rounds: '1',
    total_teams: '16'
  },
  competitionTypeId: '6094d1232484deb6cdcce47f',
  createdOn: '2023-01-25T18:47:00.619Z',
  endDate: '2023-01-27T18:00:00.000Z',
  formatString: 'Women T20',
  gameState: 0,
  gameStateText: 'Default',
  isBallThrown: false,
  lineupsOut: false,
  preSquad: true,
  result: {},
  startDate: '2023-01-27T08:00:00.000Z',
  status: 1,
  statusText: 'Scheduled',
  subtitle: '1st Semi-Final',
  teamA: {
    team_id: 126969,
    name: 'India Women Under-19s',
    short_name: 'IND-W',
    logo_url: 'https://images.entitysport.com/assets/uploads//2023/01/india-4.png'
  },
  teamB: {
    team_id: 126918,
    name: 'New Zealand Women Under-19s',
    short_name: 'NZ-W',
    logo_url: 'https://images.entitysport.com/assets/uploads//2023/01/New-zealand-33.png'
  },
  timestampEnd: 1674842400,
  timestampStart: 1674806400,
  title: 'India Women Under-19s vs New Zealand Women Under-19s',
  venue: {
    venue_id: '66',
    name: 'Senwes Park, Potchefstroom',
    location: 'Potchefstroom',
    country: 'South Africa',
    timezone: '-12'
  },
  verified: false,
  isContestListed: true,
  PreviousMatchesPointsComment: null,
  PreviousMatchesPointsStatus: 'COMPLETED'
};
export const indVsNzT20Match = {
  _id: '63cf79bd96851a4d7f28b245',
  apiMatchId: '59794',
  competition: {
    cid: 127180,
    title: 'T20 international',
    abbr: 'NZTOI',
    type: 'tour',
    category: 'international',
    match_format: 'mixed',
    season: '2023',
    status: 'live',
    datestart: '2023-01-18',
    dateend: '2023-02-01',
    country: 'int',
    total_matches: '6',
    total_rounds: '1',
    total_teams: '2'
  },
  competitionTypeId: '6094d1232484deb6cdcce47f',
  createdOn: '2023-01-24T06:25:00.618Z',
  endDate: '2023-01-27T23:30:00.000Z',
  formatString: 'T20I',
  gameState: 0,
  gameStateText: 'Default',
  isBallThrown: false,
  lineupsOut: false,
  preSquad: true,
  result: {},
  startDate: '2023-01-27T13:30:00.000Z',
  status: 1,
  statusText: 'Scheduled',
  subtitle: '1st T20I',
  teamA: {
    team_id: 25,
    name: 'India',
    short_name: 'IND',
    logo_url: 'https://images.entitysport.com/assets/uploads//2023/01/india-4.png'
  },
  teamB: {
    team_id: 7,
    name: 'New Zealand',
    short_name: 'NZ',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/New_Zealand.png'
  },
  timestampEnd: 1674862200,
  timestampStart: 1674826200,
  title: 'India vs New Zealand',
  venue: {
    venue_id: '115',
    name: 'JSCA International Stadium Complex',
    location: 'Ranchi',
    country: 'India',
    timezone: '-12'
  },
  verified: false,
  isContestListed: true,
  PreviousMatchesPointsComment: null,
  PreviousMatchesPointsStatus: 'COMPLETED'
};
export const saVsEngOdiMatch = {
  _id: '63d0d9c596851a4d7f67dcd5',
  apiMatchId: '59070',
  competition: {
    cid: 126660,
    title: 'One Day international',
    abbr: 'ETOSA',
    type: 'tour',
    category: 'international',
    match_format: 'odi',
    season: '2023',
    status: 'upcoming',
    datestart: '2023-01-27',
    dateend: '2023-02-02',
    country: 'int',
    total_matches: '3',
    total_rounds: '1',
    total_teams: '2'
  },
  competitionTypeId: '6094d1232484deb6cdcce480',
  createdOn: '2023-01-25T07:27:00.634Z',
  endDate: '2023-01-28T05:00:00.000Z',
  formatString: 'ODI',
  gameState: 0,
  gameStateText: 'Default',
  isBallThrown: false,
  lineupsOut: false,
  preSquad: true,
  result: {},
  startDate: '2023-01-27T11:00:00.000Z',
  status: 1,
  statusText: 'Scheduled',
  subtitle: '1st ODI',
  teamA: {
    team_id: 19,
    name: 'South Africa',
    short_name: 'SA',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/South_Africa.png'
  },
  teamB: {
    team_id: 490,
    name: 'England',
    short_name: 'ENG',
    logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/England.png'
  },
  timestampEnd: 1674882000,
  timestampStart: 1674817200,
  title: 'South Africa vs England',
  venue: {
    venue_id: '77',
    name: 'Mangaung Oval, Bloemfontein',
    location: 'Bloemfontein',
    country: 'South Africa',
    timezone: ''
  },
  verified: true,
  isContestListed: true
};

export const nzVsPakMatch = {
  _id: '63be86840901e17d0f43117e',
  apiMatchId: '58377',
  competition: {
    cid: 126661,
    title: 'New Zealand tour of Pakistan',
    abbr: 'NZTOP',
    type: 'tour',
    category: 'international',
    match_format: 'mixed',
    status: 'live',
    season: '2022',
    datestart: '2022-12-27',
    dateend: '2023-01-15',
    country: 'int',
    total_matches: '5',
    total_rounds: '2',
    total_teams: '2'
  },
  competitionTypeId: '604e03b191d702d01cd0a41f',
  createdOn: '2023-01-11T09:51:00.036Z',
  endDate: '2023-01-14T03:30:00.000Z',
  formatString: 'ODI',
  gameState: 3,
  gameStateText: 'Play Ongoing',
  lineupsOut: true,
  preSquad: true,
  result: {},
  startDate: '2023-01-13T09:30:00.000Z',
  status: 3,
  statusText: 'Live',
  subtitle: '3rd ODI',
  teamA: {
    team_id: 13,
    name: 'Pakistan',
    short_name: 'PAK',
    logo_url: 'https://images.entitysport.com/assets/uploads//2023/01/Pakistan-5.png'
  },
  teamB: {
    team_id: 7,
    name: 'New Zealand',
    short_name: 'NZ',
    logo_url: 'https://images.entitysport.com/assets/uploads//2023/01/New-zealand-33.png'
  },
  timestampEnd: 1673667000,
  timestampStart: 1673602200,
  title: 'Pakistan vs New Zealand',
  venue: {
    venue_id: '243',
    name: 'National Stadium',
    location: 'Karachi',
    country: 'Pakistan',
    timezone: '-12'
  },
  verified: false,
  isContestListed: true,
  description: {
    short: '₹10K + ₹3000 In ₹3!',
    long: '₹10K + ₹3000 In ₹3!'
  },
  priority: 2,
  modifiedOn: '2023-01-13T17:48:00.016Z'
};
